// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2bv-X","alert":"SettungsInbox_alert__1eleM"};